"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function AlibabaLog(props) {
  return _react2["default"].createElement(
    "svg",
    { className: props.className, width: props.size, viewBox: "0 0 162 80" },
    _react2["default"].createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
      _react2["default"].createElement(
        "g",
        { transform: "translate(-176.000000, -84.000000)", fill: "#DCDEE3" },
        _react2["default"].createElement(
          "g",
          null,
          _react2["default"].createElement(
            "g",
            null,
            _react2["default"].createElement(
              "g",
              { transform: "translate(176.000000, 84.000000)" },
              _react2["default"].createElement("path", {
                d: "M96.7467744,68.1341738 C90.2730902,68.4145478 90.9234603,65.0801004 94.7156185,59.9031956 C103.590669,48.1174763 120.39023,31.6655333 120.97056,20.0200009 C121.991141,4.79970063 106.563361,-0.146896958 90.7133407,0.00330337356 C79.6470428,0.153503705 68.2305455,3.2776706 60.456121,6.04135671 C33.610843,15.4338841 16.7412423,30.4939707 6.11519486,47.1662075 C-5.16122269,63.6982573 -1.44911008,79.4893189 22.3344254,80 C40.5748063,79.2690251 52.4215484,74.2623473 64.7685752,68.0040002 C63.6779545,68.3144142 46.0979495,73.1608782 31.8198237,73.1608782 C26.3867316,73.1608782 21.4339129,72.4599434 18.0419825,70.5373791 C16.7412423,69.8064042 15.2804109,68.7950553 14.9202059,65.9512623 C14.8401603,60.0433826 24.7357921,53.9352358 30.2699416,51.9726181 L30.2699416,41.9993161 C41.6854383,46.0046583 55.0730574,44.7630022 66.6296344,36.3217436 C67.0698849,37.262999 67.3600501,38.6548554 67.2099647,39.9666049 L69.2521269,39.9666049 C69.7614167,35.9612628 66.9197995,32.0961076 62.5573168,31.8057203 C63.7980229,32.897176 64.8186037,33.6982444 65.2498491,34.4292194 C65.2498491,34.5093262 64.9586834,34.7196067 64.9586834,34.7196067 C50.0501988,45.123483 35.7220445,40.3270857 34.3412587,39.9666049 L42.5559337,31.8858271 L40.3046525,26.0580542 C56.6739685,20.3804817 70.4217925,16.0146587 92.8145365,12.1595169 L87.8026842,8.00397437 L90.4231756,6.4018375 C103.940869,10.1868859 112.81692,12.9605853 112.316635,20.080081 C112.066493,21.3117238 111.615236,22.6635267 110.934849,24.1655301 C107.002611,31.8858271 95.2959487,44.7630022 90.5542502,50.1501874 C87.4414787,53.7249553 84.3797362,57.209603 82.1984948,60.5640771 C79.9472136,63.9085378 78.5664278,67.0427181 78.4863822,70.026698 C78.7765473,93.3878562 147.955918,59.1121405 161.344538,50.0100005 C141.552274,58.4512591 120.240145,66.6121438 96.7467744,68.1341738"
              })
            )
          )
        )
      )
    )
  );
}

exports["default"] = AlibabaLog;
module.exports = exports["default"];